/**
 * Extracts the video ID from a YouTube or Vimeo URL.
 * @param url
 * @returns {string} The extracted video ID, or an empty string if not found.
 */
export const getVideoIdFromUrl = (url: string) => {
  if (!url) return '';

  const parsedUrl = new URL(url?.includes('http') ? url : `https://${url}`);

  // Case 1: Standard link -> youtube.com/watch?v=VIDEO_ID
  if (
    parsedUrl.hostname.includes('youtube.com') &&
    parsedUrl.searchParams.get('v')
  ) {
    return parsedUrl.searchParams.get('v') ?? '';
  }

  // Case 2: Shortened link -> youtu.be/VIDEO_ID
  if (parsedUrl.hostname.includes('youtu.be')) {
    return parsedUrl.pathname.split('/')[1] ?? '';
  }

  // Case 3: Embed link -> youtube.com/embed/VIDEO_ID
  if (
    parsedUrl.hostname.includes('youtube.com') &&
    parsedUrl.pathname.startsWith('/embed/')
  ) {
    return parsedUrl.pathname.split('/')[2] ?? '';
  }

  // Case 4: Shorts link -> youtube.com/shorts/VIDEO_ID
  if (
    parsedUrl.hostname.includes('youtube.com') &&
    parsedUrl.pathname.startsWith('/shorts/')
  ) {
    return parsedUrl.pathname.split('/')[2] ?? '';
  }

  // Case 5: Vimeo -> vimeo.com/VIDEO_ID
  if (parsedUrl.hostname.includes('vimeo.com')) {
    return parsedUrl.pathname.split('/')[1] ?? '';
  }

  return '';
};
